/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import './Hero.css';
// Import the image directly
import profileImage from '../assets/images/umar.jpg';
// Import your CV file
import cvPdf from '../assets/documents/CV.pdf';

const Hero = ({ scrollToSection }) => {

  const handleDownloadCV = () => {
    // Create a temporary anchor element
    const link = document.createElement('a');
    link.href = cvPdf;
    link.download = 'Umar_Zayyar_FullStack_Developer_CV.pdf'; // Name of the downloaded file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Social media links data
  const socialLinks = [
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/checkpoint/challenge/AgHuJmskSg4DOQAAAZqWc61_mGOljyJiK1kJ0Qptdn9sugtep3Emrt964V1_g1gojSf_TzcuoAW_bUIElCnucXg9hN-gcQ?ut=2CjiXC2hCAuc01',
      icon: 'fab fa-linkedin',
      color: '#0077b5'
    },
    {
      name: 'GitHub',
      url: 'https://github.com/',
      icon: 'fab fa-github',
      color: '#333'
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/umarzayyar', // Replace with your Twitter URL
      icon: 'fab fa-twitter',
      color: '#1da1f2'
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/umar_zayyar1/', // Replace with your Instagram URL
      icon: 'fab fa-instagram',
      color: '#e4405f'
    },
    {
      name: 'Portfolio',
      url: 'https://umarzayyar.dev', // Replace with your portfolio URL
      icon: 'fas fa-globe',
      color: '#4a6cf7'
    },
    {
      name: 'Email',
      url: 'mailto:umarzayyar62@gmail.com',
      icon: 'fas fa-envelope',
      color: '#ea4335'
    }
  ];

  return (
    <section className="hero" id="home">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-text-content">
              <h3>Hello, it's Me</h3>
              <h1>Umar Zayyar</h1>
              <h2>And I'm a <span className="highlight">Full Stack Developer</span></h2>
              <p>
                Passionate full stack developer specializing in creating innovative web and mobile applications.
                I bring ideas to life with modern technologies and clean code.
              </p>
              <div className="hero-buttons">
                <button
                  className="btn btn-primary"
                  onClick={() => scrollToSection('portfolio')}
                >
                  View Portfolio
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={handleDownloadCV}
                >
                  <i className="fas fa-download"></i>
                  Download CV
                </button>
              </div>

              {/* Social Links */}
              <div className="hero-social">
                {socialLinks.map((social, index) => (
                  <a
                    key={social.name}
                    href={social.url}
                    className="social-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Visit my ${social.name}`}
                    style={{ '--social-color': social.color }}
                  >
                    <i className={social.icon}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="hero-image">
            <div className="image-container">
              <div className="profile-image-wrapper">
                <img
                  src={profileImage}
                  alt="Umar Zayyar - Full Stack Developer"
                  className="profile-image"
                  onError={(e) => {
                    // Fallback if image fails to load
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                {/* Fallback if image doesn't exist */}
                <div className="image-fallback">
                  <i className="fas fa-user"></i>
                  <span>UZ</span>
                </div>
              </div>
              <div className="floating-elements">
                <div className="floating-element element-1">
                  <i className="fab fa-react"></i>
                </div>
                <div className="floating-element element-2">
                  <i className="fab fa-js"></i>
                </div>
                <div className="floating-element element-3">
                  <i className="fab fa-node-js"></i>
                </div>
                <div className="floating-element element-4">
                  <i className="fas fa-database"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;